module.exports = __webpack_public_path__ + "static/esgi-0535917317ce03e94eaf7ba92bc81503.jpg";